const inline = (text) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) => (part.startsWith("**") && part.endsWith("**") ? <strong key={i}>{part.slice(2, -2)}</strong> : part));

export const MiniMarkdown = ({ text }) => {
  const blocks = [];
  let list = null;
  text.split("\n").forEach((raw, i) => {
    const line = raw.trim();
    const li = line.match(/^([-*•]|\d+\.)\s+(.*)/);
    if (li) {
      if (!list) blocks.push((list = { type: "ul", items: [] }));
      list.items.push(li[2]);
      return;
    }
    list = null;
    if (!line) return;
    const h = line.match(/^#{1,4}\s+(.*)/);
    blocks.push(h ? { type: "h", text: h[1], key: i } : { type: "p", text: line, key: i });
  });
  return (
    <div className="space-y-2 text-sm leading-relaxed">
      {blocks.map((b, i) =>
        b.type === "ul" ? (
          <ul key={i} className="list-disc space-y-1 pl-5">{b.items.map((t, j) => <li key={j}>{inline(t)}</li>)}</ul>
        ) : b.type === "h" ? (
          <p key={i} className="pt-1 font-display font-bold">{inline(b.text)}</p>
        ) : (
          <p key={i}>{inline(b.text)}</p>
        )
      )}
    </div>
  );
};
